import { useLocalEmergencyPhoneNumber } from '../../hooks/use-local-emergency-phone-number'
import { Button } from './button'
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useState } from 'react'

export const LocalEmergencyCallButton = () => {
  const { localRescueAreaNumbers } = useLocalEmergencyPhoneNumber()
  const [open, setOpen] = useState(false)


  if (!localRescueAreaNumbers.length) {
    return null
  }
  return (
    <>
      <Button
        className="w-28 h-16 items-center rounded-2xl"
        onClick={() => setOpen(true)}
      >
        <p className="text-xl">Call local rescue services</p>
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Call local rescue services</DialogTitle>
        {localRescueAreaNumbers.length > 0 && (
          <DialogContent>
            <DialogContentText>
              <div className="overflow-y-auto max-h-96 flex flex-col gap-2">
                {localRescueAreaNumbers.map((number) => (
                  <div className="border p-1 px-2 flex flex-row justify-between rounded-lg">
                    <p key={number.name}>{number.name}</p>
                    <a
                      className="text-primary-black underline"
                      href={`tel:${number.number}`}
                    >
                      {number.number}
                    </a>
                  </div>
                ))}
              </div>
            </DialogContentText>
          </DialogContent>
        )}
      </Dialog>
    </>
  )
}
